var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35114_34530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 1.25C10.5552 1.25 11.0669 1.54297 11.3482 2.02344L19.7857 16.3984C20.0708 16.8828 20.0708 17.4805 19.7935 17.9648C19.5161 18.4492 18.9966 18.75 18.438 18.75H1.56301C1.00442 18.75 0.484886 18.4492 0.207543 17.9648C-0.0698012 17.4805 -0.0658949 16.8789 0.215355 16.3984L8.65286 2.02344C8.93411 1.54297 9.44582 1.25 10.0005 1.25ZM10.0005 6.25C9.48098 6.25 9.06301 6.66797 9.06301 7.1875V11.5625C9.06301 12.082 9.48098 12.5 10.0005 12.5C10.52 12.5 10.938 12.082 10.938 11.5625V7.1875C10.938 6.66797 10.52 6.25 10.0005 6.25ZM11.2505 15C11.2505 14.3086 10.6919 13.75 10.0005 13.75C9.30911 13.75 8.75051 14.3086 8.75051 15C8.75051 15.6914 9.30911 16.25 10.0005 16.25C10.6919 16.25 11.2505 15.6914 11.2505 15Z",
    fill: "#FF6B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.bda615629dc5c8cc7d2ff0855a1cc64c.svg";
export { ForwardRef as ReactComponent };